import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  styleUrls: ['spinner.scss'],
  templateUrl: `./spinner.html`,

  imports: [CommonModule],
})
export class SpinnerComponent {
  color = input<string>('text-color');
  type = input<string>('');
  default = computed(() => this.type() != 'dots');
}
